import { authAxios as axios } from "shared-auth";
import { config } from "../../../../../../../config";

export function useSubmitPurchase(addOns: string[]) {
  return () => axios.post(`${config.billingApiUrl}addons/purchase`, { addOns });
}
